export { ApplicationLauncherComponent } from './application-launcher.component';
export { ApplicationLauncherModule } from './application-launcher.module';
